import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { SEOHelmet } from '@/components/SEOHelmet';

export default function GuidesPage() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="min-h-screen flex flex-col">
      <SEOHelmet
        title="Guides & Resources"
        description="Explore all CSSBuy guides, reviews, safety tips, and resources for smarter product research."
        keywords="CSSBuy guides, CSSBuy resources, CSSBuy review, CSSBuy safety, CSSBuy shipping"
        pathname="/guides"
        lang={lang}
      />
      <Navbar />
      <main className="flex-1 pt-16">
        {/* Hero */}
        <section className="bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-8 py-12 md:py-20 max-w-5xl mx-auto text-center">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              {t('guides_title')}
            </h1>
            <p className="text-base text-foreground-600 max-w-2xl mx-auto">
              {t('guides_subtitle')}
            </p>
          </div>
        </section>

        {/* Article Grid */}
        <section className="py-12 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {articles.map((article) => {
                const title = lang === 'pt' ? article.titlePt : lang === 'de' ? article.titleDe : article.title;
                const desc = lang === 'pt' ? article.descriptionPt : lang === 'de' ? article.descriptionDe : article.description;
                return (
                  <a
                    key={article.id}
                    href={`/article/${article.slug}`}
                    className="group block bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-300 transition-all hover:shadow-sm"
                  >
                    <div className="flex items-center gap-2 mb-3">
                      <span className="text-xs text-primary-600 bg-primary-100 px-2 py-1 rounded-md font-medium">{article.category}</span>
                      <span className="text-xs text-foreground-400">{article.readingTime} {t('reading_time')}</span>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                      {title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      {desc}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-400">{article.updatedDate}</span>
                      <span className="inline-flex items-center gap-1 text-sm text-primary-600 group-hover:gap-2 transition-all">
                        {t('read_guide')}
                        <i className="ri-arrow-right-line" />
                      </span>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-8 max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">
              {t('final_cta_title')}
            </h2>
            <p className="text-foreground-600 mb-6">
              {t('final_cta_subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all text-sm"
              >
                {t('final_cta_button')}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 border border-primary-300 text-primary-700 font-medium rounded-lg hover:bg-primary-50 transition-all text-sm"
              >
                {t('main_cta_button')}
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}